import Vue from 'vue'
import VueRouter from 'vue-router'
import Dev from './components/Dev.vue'
import DevTmp from './components/DevTmp.vue'
import HelloWorld from './components/HelloWorld.vue'
import Home from './components/Home.vue'
import Login from './components/Login.vue'
import UserSettings from './components/UserSettings.vue'
import Stats from './components/Stats.vue'
import Help from './components/Help.vue'
import Val from './components/val/Val.vue'
import ValDetails from './components/val/ValDetails.vue'
import NapDetails from './components/settings/NapDetails.vue'
import WaterDetails from './components/settings/WaterDetails.vue'
import PitchDetails from './components/settings/PitchDetails.vue'
import Splash from './components/Splash.vue'
import DemoQueries from './components/DemoQueries.vue'
import Logout from './components/Logout.vue'
import HelpAdmin from './components/HelpAdmin'
import StatsAdmin from './components/StatsAdmin.vue'
import TermsOfService from './components/TermsOfService.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: Home
},
{
  path: '/login',
  component: Login
},
{
  path: '/logout',
  component: Logout
},
{
  path: '/user',
  component: UserSettings
},
{
  path: '/hello-world',
  component: HelloWorld
},
{
  path: '/dev',
  component: Dev
},
{
  path: '/dev-tmp',
  component: DevTmp
},
{
  path: '/splash',
  component: Splash
},

{
  path: '/home',
  component: Home
},
{
  path: '/stats',
  component: Stats
},
{
  path: '/help',
  component: Help
},
{
  path: '/terms',
  component: TermsOfService
},
{
  path: '/val',
  component: Val
},
{
  path: '/val/settings',
  component: ValDetails
},
{ path: '/val/:actId', component: Val, props: true },
{ path: '/val/:actId/:intensity', component: Val, props: true },
{ path: '/val/:actId/:intensity/:duration', component: Val, props: true },
{ path: '/queries', component: DemoQueries },
{
  path: '/nap/settings',
  component: NapDetails
},
{
  path: '/water/settings',
  component: WaterDetails
},
{
  path: '/pitch/settings',
  component: PitchDetails
},
{
  path: '/help/admin',
  component: HelpAdmin
},
{
  path: '/stats/admin',
  component: StatsAdmin
},
{
  path: '/admin/help',
  component: HelpAdmin
},
{
  path: '/admin/stats',
  component: StatsAdmin
}
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router.js